import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Category } from '../types/ProductType';

type CategoryFilterProps = {
  categories: Category[];
  currentCategoryId?: string | undefined;
  onCategorySelect?: (categoryId: string | null) => void;
  parentCategoryName?: string;
};

export const CategoryFilter: React.FC<CategoryFilterProps> = ({
  categories,
  currentCategoryId,
  onCategorySelect,
  parentCategoryName
}) => {
  const navigate = useNavigate();

  const handleCategoryNavigate = (categorySlug: string) => {
    navigate(`/category/${categorySlug}`);
  };

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
      {/* Header */}
      <div className="bg-gradient-to-r from-indigo-50 to-blue-50 px-5 py-4 border-b border-gray-200">
        <h3 className="text-lg font-semibold text-gray-900 flex items-center">
          <svg 
            className="w-5 h-5 mr-2 text-indigo-600" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M4 6h16M4 12h16M4 18h16" 
            />
          </svg>
          Danh mục
        </h3>
      </div>
      
      {/* Content */}
      <div className="p-4">
        {categories.length === 0 ? (
          <p className="text-sm text-gray-500 py-2">Không có danh mục con</p>
        ) : (
          <nav className="space-y-1">
            {categories.map((category) => (
              <button
                key={category.id}
                onClick={() => handleCategoryNavigate(category.slug)}
                className={`w-full text-left px-4 py-3 text-sm rounded-lg transition-all duration-200 flex items-center group ${
                  currentCategoryId === category.id
                    ? 'bg-indigo-50 text-indigo-700 font-medium border-l-4 border-indigo-600 shadow-sm'
                    : 'text-gray-700 hover:bg-gray-50 hover:border-l-4 hover:border-gray-300 border-l-4 border-transparent'
                }`}
              >
                <svg 
                  className={`w-4 h-4 mr-3 transition-colors ${
                    currentCategoryId === category.id 
                      ? 'text-indigo-600' 
                      : 'text-gray-400 group-hover:text-gray-600'
                  }`}
                  fill="none" 
                  stroke="currentColor" 
                  viewBox="0 0 24 24"
                >
                  <path 
                    strokeLinecap="round" 
                    strokeLinejoin="round" 
                    strokeWidth={2} 
                    d="M9 5l7 7-7 7" 
                  />
                </svg>
                <span className="truncate">{category.name}</span>
              </button>
            ))}
          </nav>
        )}
      </div>
    </div>
  );
};

